export default __webpack_public_path__ + "static/media/greenTheme-girl.b129a68f.svg";